import { render, staticRenderFns } from "./ProtocolsByCurrentPeriod.vue?vue&type=template&id=f2e98ea8"
import script from "./ProtocolsByCurrentPeriod.vue?vue&type=script&lang=js"
export * from "./ProtocolsByCurrentPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports